export default "__VITE_ASSET__CarlesFt__"